import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import CambiarContrasena from "./pages/CambiarContrasena";
import Dashboard from "./pages/Dashboard";
import Ranking from "./pages/Ranking";
import Analisis from "./pages/Analisis";
import DiferenciaFonasa from "./pages/DiferenciaFonasa";
import Vendedores from "./pages/Vendedores";
import Licencias from "./pages/Licencias";
import Grupos from "./pages/Grupos";
import Guardias from "./pages/Guardias";
import Solicitudes from "./pages/Solicitudes";
import Asistencia from "./pages/Asistencia";
import VentasHistoricas from "./pages/VentasHistoricas";
import MiHistorial from "./pages/MiHistorial";
import FonasaNoVendido from "./pages/FonasaNoVendido";
import FonasaRegistro from "./pages/FonasaRegistro";
import Layout from "./components/Layout";

const ProtectedRoute = ({ children, requireManage = false, requireAuditor = false }) => {
  const { user, loading, canManage, isAuditor, mustChangePassword } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F9]">
        <div className="text-neutral-500 text-sm uppercase tracking-wider">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/cambiar-contrasena" replace />;
  }

  if (requireAuditor && !isAuditor) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireManage && !canManage) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppRoutes() {
  const { user, loading, mustChangePassword } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F9]">
        <div className="text-neutral-500 text-sm uppercase tracking-wider">Cargando...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? (mustChangePassword ? <Navigate to="/cambiar-contrasena" replace /> : <Navigate to="/dashboard" replace />) : <Login />} />
      <Route path="/register" element={user ? <Navigate to="/dashboard" replace /> : <Register />} />
      <Route path="/cambiar-contrasena" element={user ? (mustChangePassword ? <CambiarContrasena /> : <Navigate to="/dashboard" replace />) : <Navigate to="/login" replace />} />
      
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="mi-historial" element={<MiHistorial />} />
        <Route path="ranking" element={<ProtectedRoute requireManage><Ranking /></ProtectedRoute>} />
        <Route path="analisis" element={<ProtectedRoute requireManage><Analisis /></ProtectedRoute>} />
        <Route path="asistencia" element={<ProtectedRoute requireManage><Asistencia /></ProtectedRoute>} />
                <Route path="ventas-historicas" element={<ProtectedRoute requireAuditor><VentasHistoricas /></ProtectedRoute>} />
        <Route path="diferencia-fonasa" element={<DiferenciaFonasa />} />
        <Route path="fonasa-registro" element={<FonasaRegistro />} />
        <Route path="vendedores" element={<ProtectedRoute requireManage><Vendedores /></ProtectedRoute>} />
        <Route path="licencias" element={<Licencias />} />
        <Route path="grupos" element={<ProtectedRoute requireManage><Grupos /></ProtectedRoute>} />
        <Route path="guardias" element={<Guardias />} />
        <Route path="fonasa-listado-more" element={<ProtectedRoute requireAuditor><FonasaNoVendido /></ProtectedRoute>} />
        <Route path="solicitudes" element={<ProtectedRoute requireAuditor><Solicitudes /></ProtectedRoute>} />
      </Route>
      
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
